"use client"

import { forwardRef } from "react"

interface ShareCardProps {
  type: "standard" | "daily" | "timed" | "versus"
  score: number
  gameType: string
  extra?: {
    difficulty?: string
    date?: string
    rank?: string
  }
}

const typeConfig = {
  standard: {
    label: "Classic Mode",
  },
  daily: {
    label: "Daily Challenge",
  },
  timed: {
    label: "Timed Mode",
  },
  versus: {
    label: "Versus Mode",
  },
}

export const ShareCard = forwardRef<HTMLDivElement, ShareCardProps>(
  function ShareCard({ type, score, gameType, extra }, ref) {
    const config = typeConfig[type]
    const today = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })

    return (
      <div
        ref={ref}
        style={{
          width: 480,
          height: 640,
          background: "linear-gradient(145deg, #fbf7ef 0%, #f7f2e8 58%, #eee6db 100%)",
          border: "3px solid #171717",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 48,
          fontFamily: "system-ui, -apple-system, sans-serif",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background pattern */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0.07,
            backgroundImage: `radial-gradient(circle at 2px 2px, #171717 1px, transparent 0)`,
            backgroundSize: "24px 24px",
          }}
        />

        {/* Top glow */}
        <div
          style={{
            position: "absolute",
            top: -100,
            right: -100,
            width: 300,
            height: 300,
            background: "#ff6f61",
            borderRadius: "50%",
            border: "2px solid #171717",
            opacity: 0.9,
          }}
        />

        {/* Content */}
        <div style={{ position: "relative", zIndex: 1, textAlign: "center", width: "100%" }}>
          {/* Logo area */}
          <div style={{ marginBottom: 48, display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 10,
                background: "#ff6f61",
                border: "2px solid #171717",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 900,
                color: "#171717",
              }}
            >
              HL
            </div>
            <span style={{ fontSize: 18, fontWeight: 800, color: "#171717", letterSpacing: "-0.03em" }}>
              Higher Lower Game
            </span>
          </div>

          {/* Score */}
          <div
            style={{
              display: "inline-flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "32px 56px",
              borderRadius: 24,
              background: "#fbf7ef",
              border: "2px solid #171717",
              boxShadow: "10px 10px 0 #ff6f61",
              marginBottom: 32,
            }}
          >
            <div style={{ fontSize: 80, fontWeight: 900, color: "#171717", lineHeight: 1 }}>
              {score}
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#b83f34",
                textTransform: "uppercase",
                letterSpacing: "0.15em",
                marginTop: 8,
              }}
            >
              Score
            </div>
          </div>

          {/* Game type */}
          <div style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: "#171717" }}>
              {gameType}
            </div>
          </div>

          {/* Mode label + difficulty */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 8 }}>
            <span
              style={{
                display: "inline-block",
                padding: "4px 12px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 700,
                background: "#ff6f61",
                border: "1px solid #171717",
                color: "#171717",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              }}
            >
              {config.label}
            </span>
            {extra?.difficulty && (
              <span
                style={{
                  display: "inline-block",
                  padding: "4px 12px",
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 700,
                  background: "#eee6db",
                  border: "1px solid #d8d0c4",
                  color: "#655d54",
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                }}
              >
                {extra.difficulty}
              </span>
            )}
          </div>

          {/* Date */}
          <div style={{ fontSize: 14, color: "#655d54", marginBottom: 48 }}>
            {extra?.date || today}
          </div>

          {/* URL */}
          <div style={{ fontSize: 14, fontWeight: 700, color: "#171717" }}>
            playhigherlower.com
          </div>
        </div>
      </div>
    )
  }
)
